import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.a`
  cursor: pointer;
  width: fit-content;
  display: inline-block;
  &:hover {
    color: var(--color-primaryButton);
  }
  &:focus-visible {
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

interface LinkProps {
  href?: string;
  ariaLabel?: string;
  children?: React.ReactNode;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  target?: string;
  'data-testid'?: string;
}

const Link = ({
  href,
  ariaLabel,
  children,
  className,
  onClick,
  target,
  'data-testid': dataTestId = 'Link',
}: LinkProps) => {
  // Detect standard web URLs; defaults them to open in a new tab
  const isHttp = typeof href === 'string' && /^(https?:)/.test(href);
  // Detect tel/mailto schemes; avoid opening these in a new tab
  const isExternalScheme = typeof href === 'string' && /^(tel:|mailto:)/.test(href);
  // Final target: honor explicit prop, else use _blank for http/https only
  const resolvedTarget = typeof target !== 'undefined' ? target : isHttp ? '_blank' : undefined;
  // Add security attributes when opening in a new tab
  const rel = resolvedTarget === '_blank' ? 'noopener noreferrer' : undefined;

  return (
    <Wrapper
      className={className}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      href={href}
      target={isExternalScheme ? undefined : resolvedTarget}
      rel={rel}
      onClick={onClick}
    >
      {children}
    </Wrapper>
  );
};

export default Link;
